import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { AgendaModel, AgendaServico,  ServicoRecepcao } from "@/models/AgendaModel";
import { getMecanicos, getConsultores, getBaseAgendamento, getBaseAgendamentoEntrega, getServicosAgendados, getServicosParalizados, getOsAberta, getDataByKeyRedis, getVeiculosAgenda, getStatusKanban, getStatusKanbanParalisado, getPassantesWithoutAgendaVeiculo } from "@/services/AgendaService";
import moment from "moment";
import useUtilChanges from "@/composables/UtilChanges";

const { trataNomeConsultor,replacePlaca , cutChassi } = useUtilChanges();

function trataNome(nome) {
  if(!nome || nome == "undefined" || nome == undefined){
    return "";
  }
  const arrayNomes = nome.replaceAll(/[&\/\\#,+()$~%.'":*?<>{}]/g, "").replaceAll("-", "").split(" ").filter(nome => nome);
  let nomeTratado = `${arrayNomes[0]}` 

  if(arrayNomes.length > 1){
    if(arrayNomes[1].toLowerCase() != "de"){
      nomeTratado += ` ${arrayNomes[1][0]}.`;
    } else if(arrayNomes.length > 2) {
      nomeTratado += ` ${arrayNomes[2][0]}.`
    }
  }

  return nomeTratado;
};

@Module
export default class AgendaModule extends VuexModule implements AgendaModel {
  mecanicos:any = [];
  consultores:any = [];
  eventos:any = [];
  baseAgendamentos:any = [];
  agendaVeiculos:any = [];
  passantesWithoutAgendaVeiculo:any = [];
  agendaVeiculosStatus:any = [];
  agendaVeiculosStatusParalisado:any = [];
  servicosParalizado:AgendaServico[] = [];
  baseServicos:any = [];
  baseEntregas:any = [];
  veiculoRecepcao: ServicoRecepcao[] = [];
  modeloAgenda:String = "";
  osAberta  = {
    passante : [],
    agendado : [],
  } 
  countOsAberta = 0;
  cores = ["#34252F", "#2EC4B6", "#2A628F", "#FF9F1C", "#D89D6A", "#FF1053", "#F6BD60",  "#F7EDE2"]; 
  refLastUpdated:any = {
    lastBaseAgendamentos: "",
    lastBaseServicos: "",
    lastBaseEntregas: ""
  };
  lastConcessionaria: string = "";

  /**
   * Get modelo agenda
   * @returns string com o nome do modelo da agenda
   */
  get modeloAgendaName(): any {
    return this.modeloAgenda;
  }

  get coresAgenda(): any {
    return this.cores;
  }

  get refLastUpdatedTime(): any {
    return this.refLastUpdated;
  }

  /**
   * Get mecanico list
   * @returns array com os mecânicos da concessionária
   */
  get mecanicosList(): any {
    return this.mecanicos;
  }

  /**
   * Get consultores list
   * @returns array com os mecânicos da concessionária
   */
  get consultoresList(): any {
    return this.consultores;
  }

  /**
   * Get base veiculos na recepçao
   * @returns veiculos Recepção
   */
  get baseVeiculosRecepcao(): ServicoRecepcao[] {    
    return this.veiculoRecepcao 
  }

  /**
   * quantidade de veiculos com os aberta
   * @returns number
   */
  get countBaseVeiculosOsAberta(): number {  
    return this.countOsAberta
  }

   /**
   * Comtagem de veiculos com os Aperta
   * @returns array com os veiculos com os aberta 
   */
   get baseVeiculosOsAberta() {  
    return this.osAberta
  }

  /**
   * Get base agendamentos List
   * @returns array com os agendamentos do dia
   */
  get baseAgendamentosList(): any {
    const auxBase = this.baseAgendamentos.map(agendamento => Object.assign({}, agendamento));

    return auxBase;
  }

  get basePassantesWithoutAgendaVeiculoList(): any {
    const auxBase = this.passantesWithoutAgendaVeiculo.map(agendamento => Object.assign({}, agendamento));

    return auxBase;
  }

  get agendaVeiculosList(): any {
    const auxBase = this.agendaVeiculos.map(agendamento => Object.assign({}, agendamento));

    return auxBase;
  }

  get agendaVeiculosStatusList(): any {
    const auxBase = this.agendaVeiculosStatus.map(agendamento => Object.assign({}, agendamento));

    return auxBase;
  }

  get agendaVeiculosStatusParalisadoList(): any {
    const auxBase = this.agendaVeiculosStatusParalisado.map(agendamento => Object.assign({}, agendamento));

    return auxBase;
  }

  /**
   * Get base Servicos List
   * @returns array com os Servicos paralizado 
   */

  get servicoParalizadoList(): AgendaServico[] {    
    return this.servicosParalizado
  }

  /**
   * Get base Servicos List
   * @returns array com os Servicos do dia
   */
  get baseServicosList(): any {
    const auxBase = this.baseServicos.map(agendamento => Object.assign({}, agendamento));

    return auxBase;
  }

  /**
   * Get base Entrega List
   * @returns array com os Entrega do dia
   */
  get baseEntregaList(): any {
    const auxBase = this.baseEntregas.map(agendamento => Object.assign({}, agendamento));

    return auxBase;
  }

  /**
   * Get concessionariaSelectedInfo
   * @returns array com os eventos da concessionária
   */
  get eventosList(): any {
    return this.eventos;
  }

  @Mutation
  [Mutations.SET_VEICULO_RECEPCAO](servico) {
    this.veiculoRecepcao = servico ?? [];
  }

  @Mutation
  [Mutations.SET_OS_ABERTA](servico){
    this.countOsAberta = servico.agendado.length + servico.passante.length
    this.osAberta = servico;
  }
  
  @Mutation
  [Mutations.SET_CONSULTORES_LIST](consultores) {
    this.consultores = consultores ?? [];
  }

  @Mutation
  [Mutations.SET_MECANICO_LIST](mecanicos) {
    this.mecanicos = mecanicos ?? [];
  }

  @Mutation
  [Mutations.SET_BASE_AGENDAMENTOS](agendamentos) {
    this.baseAgendamentos = agendamentos ?? [];
  }

  @Mutation
  [Mutations.SET_BASE_AGENDA_VEICULOS](agendaVeiculos) {
    this.agendaVeiculos = agendaVeiculos ?? [];
  }

  @Mutation
  [Mutations.SET_BASE_PASSANTES_WITHOUT_AGENDA_VEICULOS](agendaVeiculos) {
    this.passantesWithoutAgendaVeiculo = agendaVeiculos ?? [];
  }

  @Mutation
  [Mutations.SET_AGENDA_VEICULOS_STATUS](agendaVeiculosStatus) {
    this.agendaVeiculosStatus = agendaVeiculosStatus ?? [];
  }

  @Mutation
  [Mutations.SET_AGENDA_VEICULOS_STATUS_PARALISADO](agendaVeiculosStatusParalisado) {
    this.agendaVeiculosStatusParalisado = agendaVeiculosStatusParalisado ?? [];
  }

  @Mutation
  [Mutations.SET_SERVICOS_PARALIZADOS](servico) {
    this.servicosParalizado = servico ?? [];
  }
  
  @Mutation
  [Mutations.SET_BASE_SERVICOS](agendamentos) {
    this.baseServicos = agendamentos ?? [];
  }

  @Mutation
  [Mutations.SET_BASE_ENTREGAS](agendamentos) {
    this.baseEntregas = agendamentos ?? [];
  }


  @Mutation
  ["setLastBaseAgendamentos"](){
    this.refLastUpdated.lastBaseAgendamentos = moment();
  }

  @Mutation
  ["setLastBaseServicos"](){
    this.refLastUpdated.lastBaseServicos = moment();
  }

  @Mutation
  ["setLastBaseEntrega"](){
    this.refLastUpdated.lastBaseEntregas = moment();
  }
  
  @Mutation
  ["setLastConcessionaria"](codConcessionaria: string){
    this.lastConcessionaria = codConcessionaria;
  }

  @Mutation
  [Mutations.SET_MODELO_AGENDA](modelo) {
    const modeloTratado = modelo[0]?.toUpperCase() + modelo?.substr(1);

    this.modeloAgenda = modeloTratado;
  }

  @Action
  async [Actions.SET_OS_ABERTA]() {
    try {
      this.context.commit("setLastBaseAgendamentos");
      const concessionariaSelected = this.context.getters.concessionariaSelectedInfo;
      const response = await getOsAberta(concessionariaSelected.codConcessionaria);
      this.context.commit(Mutations.SET_OS_ABERTA, response);
      return true;
    } catch (error) {
      this.context.commit(Mutations.SET_ERROR, error);
      throw error;
    }
  }

  @Action
  [Actions.SET_VEICULO_RECEPCAO](){
    const statusLegiveis = {
      1: { statusOS: "Aguardando Serviço", progressoOS: "1" },
      2: { statusOS: "Em Serviço", progressoOS: "2" },
      3: { statusOS: "Aguardando Inspeção", progressoOS: "3" },
      4: { statusOS: "Aguardando Entrega", progressoOS: "4" },
    };
    
    const tiposServico = [9, 10, 11, 12]; //eventos extra
    
    const veiculoRecepcao = this.baseServicos.reduce((arrayFinal, servico) => {
        const dataMoment = moment(servico.dataInicioServico, 'YYYY-MM-DD HH:mm:ss');
        const mesmoDia = moment().isSame(dataMoment, 'day');
    
        if (mesmoDia && !tiposServico.includes(servico.codTipoServico) && servico.osAberta) {
            const placasIguais = this.baseServicos.filter(({ placa }) => placa === servico.placa);
            let statusMinimo = placasIguais.reduce((minimo, agendamento) => Math.min(minimo, agendamento.status), Infinity);
            const statusMaximo = placasIguais.reduce((maximo, agendamento) => Math.max(maximo, agendamento.status), 0)

            if (statusMinimo === 1 && statusMaximo > 1) {
              statusMinimo = 2;
            }       
            
            if(statusMaximo == 5 || statusMinimo == 5){
              statusMinimo = 99
            }

            const { statusOS, progressoOS } = statusLegiveis[statusMinimo] || { statusOS: "Desconhecido", progressoOS: "0" };
            const consultor = servico.consultorAgendado;

            const [firstName, endName] = servico.cliente.split(' ', 2)
            const novoServico = {
                statusRecepcao: statusOS,
                placa: servico.placa ? replacePlaca(servico.placa.toUpperCase()) : cutChassi(servico.chassi,-4,'...'),
                cliente: firstName ?? '',
                placaOriginal : servico.placa ? servico.placa.trim() : null,
                modelo: servico.modelo,
                progressoOS,
                horaAgendameto: moment(servico.dataAgendamento).format('HH:mm') ?? '',
                horaServicoIniciado: servico.dataInicioServicoExecucao ? moment(servico.dataInicioServico).format('HH:mm') : 'Não iniciado',
                consultor: trataNomeConsultor(consultor),
                codTipoServico: servico.codTipoServico
            };
    
            if (!arrayFinal.some(item => {

              return item.placaOriginal === novoServico.placaOriginal
            })) {
                arrayFinal.push(novoServico);
            }
            
        }
    
        return arrayFinal;
    }, []).filter(servico => servico.progressoOS != 0)
      .sort((osTratataA, osTratadaB) => (osTratataA.progressoOS > osTratadaB.progressoOS) ? 1 : -1);
    
    this.context.commit(Mutations.SET_VEICULO_RECEPCAO, veiculoRecepcao)
  }
  
  @Action
  [Actions.SET_MODELO_AGENDA]() {
    const concessionariaSelected = this.context.getters.concessionariaSelectedInfo;
    const modeloAgenda = concessionariaSelected?.modeloAgenda;

    this.context.commit(Mutations.SET_MODELO_AGENDA, modeloAgenda);
  }

  @Action
  [Actions.RESET_AGENDA_INFO]() {
    this.context.commit(Mutations.SET_MECANICO_LIST, []);
    this.context.commit(Mutations.SET_BASE_ENTREGAS, []);
    this.context.commit(Mutations.SET_BASE_SERVICOS, []);
    this.context.commit(Mutations.SET_BASE_AGENDAMENTOS, []);
    this.context.commit(Mutations.SET_BASE_AGENDA_VEICULOS, []);
    this.context.commit(Mutations.SET_BASE_PASSANTES_WITHOUT_AGENDA_VEICULOS, []);
    this.context.commit(Mutations.SET_AGENDA_VEICULOS_STATUS, []);
    this.context.commit(Mutations.SET_AGENDA_VEICULOS_STATUS_PARALISADO, []);
    this.context.commit(Mutations.SET_SERVICOS_PARALIZADOS, []);

    this.refLastUpdated.lastBaseAgendamentos = "";
    this.refLastUpdated.lastBaseServicos = "";
    this.refLastUpdated.lastBaseEntregas = "";
  }

  @Action
  [Actions.SET_MECANICO_LIST]() {
    const concessionariaSelected = this.context.getters.concessionariaSelectedInfo;
    return new Promise<any>((resolve, reject) => {
      const defaultUserImage = "data:image/jpeg;base64,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";
       
      getMecanicos(concessionariaSelected.codConcessionaria).then(response => {
        const responseTratada = response.map(mecanico => {
          return {
            ...mecanico,
            imagem: mecanico.imagem ?? defaultUserImage
          }
        })
        this.context.commit(Mutations.SET_MECANICO_LIST, responseTratada);
        resolve(true);
      })
      .catch(response => {
        reject(response);
        this.context.commit(Mutations.SET_ERROR, response);
      });
    });
  }
  
  @Action
  [Actions.SET_CONSULTORES_LIST]() {
    const concessionariaSelected = this.context.getters.concessionariaSelectedInfo;
    return new Promise<any>((resolve, reject) => {       
      getConsultores(concessionariaSelected.codConcessionaria).then(response => {
        const responseTratada = response.map((consultor, index) => {
          return {
            ...consultor,
            nomeTratado: trataNome(consultor.nome),
            corAgenda: this.cores[index]
          }
        })
        this.context.commit(Mutations.SET_CONSULTORES_LIST, responseTratada);
        resolve(true);
      })
      .catch(response => {
        reject(response);
        this.context.commit(Mutations.SET_ERROR, response);
      });
    });
  }
  
  @Action
  [Actions.SET_BASE_AGENDAMENTOS]() {
    const concessionariaSelected = this.context.getters.concessionariaSelectedInfo;
    this.context.commit(Mutations.SET_VEICULO_RECEPCAO, [])
    return new Promise<any>((resolve, reject) => {
      this.context.commit("setLastBaseAgendamentos");
      getBaseAgendamento(concessionariaSelected.codConcessionaria, 0).then(response => {
        this.context.commit(Mutations.SET_BASE_AGENDAMENTOS, response);
        this.context.dispatch(Actions.SET_VEICULO_RECEPCAO)        
        resolve(true);
      })
      .catch(response => {
        this.refLastUpdated.lastBaseAgendamentos = "";
        reject(response);
        this.context.commit(Mutations.SET_ERROR, response);
      });
    });
  }

  @Action
  [Actions.SET_BASE_AGENDA_VEICULOS]() {
    const concessionariaSelected = this.context.getters.concessionariaSelectedInfo;
    return new Promise<any>((resolve, reject) => {
      getVeiculosAgenda(concessionariaSelected.codConcessionaria).then(response => {
        this.context.commit(Mutations.SET_BASE_AGENDA_VEICULOS, response);
        resolve(true);
      })
      .catch(response => {
        reject(response);
        this.context.commit(Mutations.SET_ERROR, response);
      });
    });
  }

  @Action
  [Actions.SET_BASE_PASSANTES_WITHOUT_AGENDA_VEICULOS]() {
    const concessionariaSelected = this.context.getters.concessionariaSelectedInfo;
    return new Promise<any>((resolve, reject) => {
      getPassantesWithoutAgendaVeiculo(concessionariaSelected.codConcessionaria).then(response => {
        this.context.commit(Mutations.SET_BASE_PASSANTES_WITHOUT_AGENDA_VEICULOS, response);
        resolve(true);
      })
      .catch(response => {
        reject(response);
        this.context.commit(Mutations.SET_ERROR, response);
      });
    });
  }
  
  @Action
  [Actions.SET_AGENDA_VEICULOS_STATUS]() {
    const concessionariaSelected = this.context.getters.concessionariaSelectedInfo;
    return new Promise<any>((resolve, reject) => {
      getStatusKanban(concessionariaSelected.codConcessionaria).then(response => {
        this.context.commit(Mutations.SET_AGENDA_VEICULOS_STATUS, response);
        resolve(true);
      })
      .catch(response => {
        reject(response);
        this.context.commit(Mutations.SET_ERROR, response);
      });
    });
  }

  @Action
  [Actions.SET_AGENDA_VEICULOS_STATUS_PARALISADO]() {
    const concessionariaSelected = this.context.getters.concessionariaSelectedInfo;
    return new Promise<any>((resolve, reject) => {
      getStatusKanbanParalisado(concessionariaSelected.codConcessionaria).then(response => {
        this.context.commit(Mutations.SET_AGENDA_VEICULOS_STATUS_PARALISADO, response);
        resolve(true);
      })
      .catch(response => {
        reject(response);
        this.context.commit(Mutations.SET_ERROR, response);
      });
    });
  }

  @Action
  [Actions.SET_SERVICOS_PARALIZADOS]() {
    const concessionariaSelected = this.context.getters.concessionariaSelectedInfo;
    return new Promise<any>((resolve, reject) => {
      this.context.commit("setLastBaseAgendamentos");
      getServicosParalizados(concessionariaSelected.codConcessionaria).then(response => {
        this.context.commit(Mutations.SET_SERVICOS_PARALIZADOS, response);
        resolve(true);
      })
      .catch(response => {
        reject(response);
        this.context.commit(Mutations.SET_ERROR, response);
      });
    });
  }

  @Action
  [Actions.SET_BASE_SERVICOS]() {
    const concessionariaSelected = this.context.getters.concessionariaSelectedInfo;
    this.context.commit(Mutations.SET_VEICULO_RECEPCAO, [])
    return new Promise<any>((resolve, reject) => { 
      this.context.commit("setLastBaseServicos");
      getServicosAgendados(concessionariaSelected.codConcessionaria, moment().format("YYYY-MM-DD")).then(response => {
        this.context.commit(Mutations.SET_BASE_SERVICOS, response);
        this.context.dispatch(Actions.SET_VEICULO_RECEPCAO)
        resolve(true);
      })
      .catch(response => {
        this.refLastUpdated.lastBaseServicos = "";
        reject(response);
        this.context.commit(Mutations.SET_ERROR, response);
      });
    });
  }

  @Action
  [Actions.SET_BASE_ENTREGAS]() {
    const concessionariaSelected = this.context.getters.concessionariaSelectedInfo;
    return new Promise<any>((resolve, reject) => {       
      getBaseAgendamentoEntrega(concessionariaSelected.codConcessionaria, 0).then(response => {
        this.context.commit(Mutations.SET_BASE_ENTREGAS, response);
        this.context.commit("setLastBaseEntrega");
        resolve(true);
      })
      .catch(response => {
        reject(response);
        this.context.commit(Mutations.SET_ERROR, response);
      });
    });
  }

  @Action
  [Actions.START_AGENDA]() {
    try {
    if(this.context.getters.concessionariaSelectedInfo?.codConcessionaria){
      this.context.dispatch(Actions.START_AGENDA_WEB_SOCKET);


      if(this.modeloAgenda == ""){
        this.context.dispatch(Actions.SET_MODELO_AGENDA);
      }
      
      if(this.mecanicos.length == 0){
        this.context.dispatch(Actions.SET_MECANICO_LIST);
      }

      if(this.consultores.length == 0){
        this.context.dispatch(Actions.SET_CONSULTORES_LIST);
      }
    }
    } catch (error) {
      console.error("Erro ao iniciar agenda socket:", error);
    }
  }

  @Action
  [Actions.START_AGENDA_WEB_SOCKET]() {
    const prefix = "ACAMPA";
    const distribuidor = this.context.getters.layoutConfig("distribuidor.distribuidor").toLowerCase();
    const socketRouteAgendamento = "getAgendamentos";
    const socketRouteServico = "getServicosAgendamentos";
    const socketRouteAgendaVeiculo = "KANBAN_SNAPSHOT";
    const socketRoutePassantesWithoutAgendaVeiculo = "PASSANTES_WITHOUT_AGENDA_VEICULO";

    if(this.lastConcessionaria){
      const lastSocketConectionAgendamento = `${prefix}_${distribuidor}_${socketRouteAgendamento}_${this.lastConcessionaria}`;
      const lastSocketConectionServico = `${prefix}_${distribuidor}_${socketRouteServico}_${this.lastConcessionaria}`;
      this.context.dispatch(Actions.REMOVE_LISTEN,{ name: lastSocketConectionAgendamento});
      this.context.dispatch(Actions.REMOVE_LISTEN,{ name: lastSocketConectionServico});
    }

    const codConcessionaria = this.context.getters.concessionariaSelectedInfo?.codConcessionaria;
    const newSocketConectionAgendamento = `${prefix}_${distribuidor}_${socketRouteAgendamento}_${codConcessionaria}`;
    const newSocketConectionServico = `${prefix}_${distribuidor}_${socketRouteServico}_${codConcessionaria}`;
    const newSocketAgendaVeiculo= `${prefix}_${distribuidor}_${socketRouteAgendaVeiculo}_${codConcessionaria}`;
    const newSocketPassantesWithoutAgendaVeiculo= `${prefix}_${distribuidor}_${socketRoutePassantesWithoutAgendaVeiculo}_${codConcessionaria}`;

    console.log("newSocketAgendaVeiculo", newSocketAgendaVeiculo);

    this.context.dispatch(Actions.NEW_LISTEN,{ name: newSocketConectionAgendamento, callbackFunction: (payload) => {
      if(payload && payload.keyRedis){
        getDataByKeyRedis(payload.keyRedis).then(response => {
          this.context.commit(Mutations.SET_BASE_AGENDAMENTOS, response);
          this.context.commit("setLastConcessionaria", codConcessionaria);      
        })
      } else {
        this.context.commit(Mutations.SET_BASE_AGENDAMENTOS, payload);
      }
    }});

    this.context.dispatch(Actions.NEW_LISTEN,{ name: newSocketConectionServico, callbackFunction: (payload) => {
      if(payload && payload.keyRedis){
        getDataByKeyRedis(payload.keyRedis).then(response => {
          this.context.commit(Mutations.SET_BASE_SERVICOS, response);
          this.context.commit("setLastConcessionaria", codConcessionaria);      
        })
      } else {
        this.context.commit(Mutations.SET_BASE_SERVICOS, payload);
      }
    }});

    this.context.dispatch(Actions.NEW_LISTEN,{ name: newSocketAgendaVeiculo, callbackFunction: (payload) => {
      if(payload && payload.keyRedis){
        getDataByKeyRedis(payload.keyRedis).then(response => {
          this.context.commit(Mutations.SET_BASE_AGENDA_VEICULOS, response);
          this.context.commit("setLastConcessionaria", codConcessionaria);      
        })
      } else {
        this.context.commit(Mutations.SET_BASE_AGENDA_VEICULOS, payload);
      }
    }});

    this.context.dispatch(Actions.NEW_LISTEN,{ name: newSocketPassantesWithoutAgendaVeiculo, callbackFunction: (payload) => {
      if(payload && payload.keyRedis){
        getDataByKeyRedis(payload.keyRedis).then(response => {
          this.context.commit(Mutations.SET_BASE_PASSANTES_WITHOUT_AGENDA_VEICULOS, response);
          this.context.commit("setLastConcessionaria", codConcessionaria);      
        })
      } else {
        this.context.commit(Mutations.SET_BASE_PASSANTES_WITHOUT_AGENDA_VEICULOS, payload);
      }
    }});

  }
}